export const POST_ACTIONS = {
  CREATE_WITH_PHONE: 'CREATE_WITH_PHONE',
  SEND_FEEDBACK_TO_PHONE: 'SEND_FEEDBACK_TO_PHONE',
  POST_VOTE: 'POST_VOTE',
};
